import React from 'react';
import styled from 'styled-components';
import { shallowEqual, useSelector } from 'react-redux';

import Loader from '../../Loader';
import { AppState } from '../../../store/interfaces';

const LoadingMap = styled.div`
  position: absolute;
  z-index: 9999;
  height: 100%;
  width: 100%;
  background: ${(props) => props.theme.map.background};
`;

export const Loading = function () {
  const isInitialized = useSelector((app: AppState) => app.map.isInitialized, shallowEqual);

  if (isInitialized) {
    return null;
  }

  return (
    <LoadingMap>
      <Loader />
    </LoadingMap>
  );
};
